export default {
      id: "filters-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#filters-usage",
      toString: function () {
        return this.url;
      }
    }